"use strict";
window.theme = window.theme || {}
theme.OptimumAllAssets = function() {
    function OptimumAllAssets() {
        this.assets = {
            scripts: theme.optimized_script,
            render: true
        }
        this.load();
        
    }
    OptimumAllAssets.prototype.load = function() {
            var _ = this;                       
        window.addEventListener('mousemove', event => {
            if(_.assets.scripts.length > 0 && _.assets.render) {
                _.assets.scripts.forEach(src => {
                    var newscript = document.createElement('script');
                    newscript.src = src;
                    document.head.appendChild(newscript);
                });             
                _.assets.render = false;
            }           
        })
        window.addEventListener('scroll', event => {
            if(_.assets.scripts.length > 0 && _.assets.render) {
                _.assets.scripts.forEach(src => {
                    var newscript = document.createElement('script');
                    newscript.src = src;
                    document.head.appendChild(newscript);
                });               
                _.assets.render = false;
            }           
        })
        window.addEventListener('touchstart', event => {
            if(_.assets.scripts.length > 0 && _.assets.render) {
                _.assets.scripts.forEach(src => {
                    var newscript = document.createElement('script');
                    newscript.src = src;
                    document.head.appendChild(newscript);
                });                  
                _.assets.render = false;
            }           
        })
        window.addEventListener('click', event => {
            if(_.assets.scripts.length > 0 && _.assets.render) {
                _.assets.scripts.forEach(src => {
                    var newscript = document.createElement('script');
                    newscript.src = src;
                    document.head.appendChild(newscript);
                });             
                _.assets.render = false;
            }           
        })
        window.addEventListener('resize', event => {
            if(_.assets.scripts.length > 0 && _.assets.render) {
                _.assets.scripts.forEach(src => {
                    var newscript = document.createElement('script');
                    newscript.src = src;
                    document.head.appendChild(newscript);
                });             
                _.assets.render = false;
            }           
        })
      
    }

    theme.OptimumAllAssets = new OptimumAllAssets;
}

theme.OptimumAllAssets();
